import _get from "lodash/get";
import styled, { css } from 'styled-components';
import { rem } from 'polished';
import carouselTheme from '../styles/carouselTheme';
var Arrow = styled.span.withConfig({
  displayName: "Arrow",
  componentId: "t9n4um-0"
})(["align-items:center;display:flex;flex-shrink:0;justify-content:center;height:", ";padding:0;width:", ";", " ", " ", ""], function (props) {
  return rem(_get(props, "theme.carousel.arrows[" + props.arrowSize + "].size", carouselTheme.carousel.arrows[props.arrowSize].size));
}, function (props) {
  return rem(_get(props, "theme.carousel.arrows[" + props.arrowSize + "].size", carouselTheme.carousel.arrows[props.arrowSize].size));
}, function (props) {
  return props.arrowType === 'primary' && css(["background-color:", ";border-radius:50%;box-shadow:1px 1px 2px rgba(0,0,0,0.5);transition:box-shadow 0.15s ease-in-out;&:active{box-shadow:1px 1px 1px rgba(0,0,0,0.25);}"], _get(props, 'theme.carousel.arrows.backgroundColor', carouselTheme.carousel.arrows.backgroundColor));
}, function (props) {
  return props.arrowType === 'default' && css(["background-color:transparent;"]);
}, function (props) {
  return props.vertical && css(["margin:0 auto;"]);
});
export default Arrow;